import { useEffect, useMemo, useState } from 'react';
import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import { useDebounce } from '../hooks';
import { LCDPRServiceCitros } from '../services/api/fiscal/LCDPR/LCDPRServiceCitros';

type TAutoCompleteOption = {
  idprodutor: number;
  label: string;
}

interface IAutoCompleteProdutorProps {
  isExternalLoading?: boolean;
  uuidprodutor?: (novoTextoselect: number | undefined) => void;
  nome?: (novoTextoselect: string | undefined) => void;
  defaultvalue?: number;
}
export const AutoCompleteProdutorListagemCitros: React.FC<IAutoCompleteProdutorProps> = ({ isExternalLoading = false, uuidprodutor, nome, defaultvalue }) => {

  const { debounce } = useDebounce();
  const [selectedId, setSelectedId] = useState<number | undefined>(defaultvalue);
  const [opcoes, setOpcoes] = useState<TAutoCompleteOption[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [busca, setBusca] = useState('');


  useEffect(() => {
    setIsLoading(true);
    debounce(() => {
      LCDPRServiceCitros.getAlllistProdutor(1, busca)
        .then((result) => {
          setIsLoading(false);
          if (result instanceof Error) {
            // alert(result.message);
          } else {
            setOpcoes(result.data.map(produtor => ({ idprodutor: produtor.idprodutor, label: produtor.nome })));
          }
        });
    });
  }, [busca]);

  const autoCompleteSelectedOption = useMemo(() => {
    if (!selectedId) return null;

    const selectedOption = opcoes.find(opcao => opcao.idprodutor === selectedId);
    if (!selectedOption) return null;

    return selectedOption;
  }, [selectedId, opcoes]);


  return (
    <Autocomplete
      openText='Abrir'
      closeText='Fechar'
      noOptionsText='Sem opções'
      loadingText='Carregando...'
      disablePortal
      options={opcoes}
      loading={isLoading}
      disabled={isExternalLoading}
      value={autoCompleteSelectedOption}
      onInputChange={(_, newValue) => setBusca(newValue)}
      onChange={(_, newValue) => { setSelectedId(newValue?.idprodutor); nome?.(newValue?.label); uuidprodutor?.(newValue?.idprodutor); setBusca(''); }}
      popupIcon={(isExternalLoading || isLoading) ? <CircularProgress size={28} /> : undefined}
      renderInput={(params) => (
        <TextField
          sx={{ width: '39ch' }}
          {...params}
          size='small'
          label="Produtor"
        />
      )}
    />
  );
};